import React, { useState } from 'react'
import PropTypes from 'prop-types'
import AddressBox from './AddressBox'
import { addressShape } from '@/checkout-instore-legacy/shipping/shapes'

function AddressSelector({
  addresses,
  modalIsClosing,
  setModalIsClosing,
  onSubmit,
}) {
  const [selectedGeoCoordinates, setSelectedGeoCoordinates] = useState(null)

  const onClick = (address) => {
    if (modalIsClosing) {
      return
    }

    setSelectedGeoCoordinates(address.geoCoordinates)
    setModalIsClosing(true)
    setTimeout(() => onSubmit(address), 1000)
  }

  return (
    <div data-cy="address-box-list">
      {addresses.map((address) => (
        <AddressBox
          address={address}
          isSelected={address.geoCoordinates === selectedGeoCoordinates}
          onClick={() => onClick(address)}
          key={`${address.addressId}${address.street}`}
        />
      ))}
    </div>
  )
}

AddressSelector.propTypes = {
  addresses: PropTypes.arrayOf(addressShape).isRequired,
  currentAddress: addressShape,
  modalIsClosing: PropTypes.bool.isRequired,
  setModalIsClosing: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
}

export default AddressSelector
